import React, { useState } from 'react'
import { array, bool, number } from 'prop-types';

import { MessageBox } from '@ajaibid/components';
import { FormatRupiah } from 'Component/NumberFormat';
import SvgTimeRewindIcon from 'Component/SvgIcon/icons/TimeRewindIcon'
import ArrowRight from 'Icon/svg/ArrowRight';

import PopupDetail from './PopupDetail';

import {
  styMessageBox,
  styTitleWrapper,
  styTitleInfo,
  styAmount,
  styAction,
} from './style'
import useEventTracker from './tracker';


const  OnGoingRdn = (props) => {
  const {
    balance,
    cashLog,
    cashRaw,
    isCenter,
    onGoingAmount,
    isShowRdnNegative,
    withAction,
  } = props

  const [isShowPopup, setIsShowPopup] = useState(false)
  const { eventClickRdnProcessed, eventViewRdnProcessedPage } = useEventTracker();
  
  const title =
    <div 
      className={styTitleWrapper({ withAction })}
      onClick={() => {
        if(withAction) {
          setIsShowPopup(true);
          eventClickRdnProcessed();
          eventViewRdnProcessedPage();
        }
      }}
    >
      <span> Saldo Diproses</span> 
      <div className={styTitleInfo}>
        <span className={styAmount}>
          <FormatRupiah value={onGoingAmount} />
        </span> 
        {
          withAction && (
            <div className={styAction}>
              <ArrowRight size={18} color="#3A83F9"/>
            </div>
          )
        }
      </div>
    </div>

  return (
    <>
      <div className={styMessageBox({isCenter})}>
        <MessageBox
          icon={<SvgTimeRewindIcon />}
          title={title}
        />
      </div>
      <PopupDetail 
        isShowPopup={isShowPopup}
        setIsShowPopup={setIsShowPopup}
        isShowRdnNegative={isShowRdnNegative}
        balance={balance}
        cashLog={cashLog}
        cashRaw={cashRaw}
        onGoingAmount={onGoingAmount}
      />
    </>
  )
}

OnGoingRdn.propTypes = {
  balance: number,
  cashLog: array,
  cashRaw: number,
  isCenter: bool,
  isShowRdnNegative: bool,
  onGoingAmount: number,
  withAction: bool,
};

OnGoingRdn.defaultProps = {
  balance: 0,
  cashLog: [],
  cashRaw: 0,
  isCenter: false,
  isShowRdnNegative: false,
  onGoingAmount: 0,
  withAction: false,
};

export default OnGoingRdn
